<template>
    <v-app>
        <AppBar @open-drawer="drawer = true"/>
        <v-main>
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>
import AppBar from '@/components/appbar/AppBar';

/**
 * Main component only includes the AppBar for all the pages after user is 
 * authenticated. It also includes de router-view for other pages.
 */
export default {
    name: 'Main',
    components: { AppBar }
}
</script>
